"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/retailer/order");
var _systemSetting = require("@/api/systemSetting");
var _auth = require("@/utils/auth");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'OrderDetail',
  props: {
    orderNo: {
      type: String,
      default: 0
    }
  },
  data: function data() {
    return {
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      form: {
        subDistributionOrderId: null,
        bizClaimType: '1',
        goodsStatus: '1',
        maxRefundFee: null,
        leavePictureLists: null,
        channelDataVisBle: true,
        proofRequired: false,
        sliderImages: []
      },
      leavePictureLists: [],
      activeNames: ['1'],
      direction: 'rtl',
      reverse: true,
      dialogVisible: false,
      orderDatalist: {},
      loading: false,
      modal2: false,
      result: [],
      resultInfo: {},
      InvoiceList: [],
      refundInfo: {},
      dialogFormVisible: false,
      channelVisBle: false
    };
  },
  watch: {
    // orderData: {
    //   handler(newVal, oldVal) {
    //     this.orderDatalist = newVal;
    //   },
    //   deep: true, // 对象内部属性的监听，关键。
    // },
  },
  mounted: function mounted() {},
  methods: {
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    openLogistics: function openLogistics(data) {
      this.getOrderLogisticsData(data.subDistributionOrderId);
      this.modal2 = true;
    },
    // 获取订单退款信息
    getRefundOrderDetail: function getRefundOrderDetail(id) {
      var _this = this;
      (0, _order.refundOrderDetailApi)(id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this.refundInfo = res;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 获取订单物流信息
    getOrderLogisticsData: function getOrderLogisticsData(id) {
      var _this2 = this;
      (0, _order.getLogisticsBySupplierInfoApi)(id).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                _this2.resultInfo = res;
                _this2.result = res.list;
              case 1:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    confirmGoods: function confirmGoods(data) {
      var _this3 = this;
      this.$modalSure('确认核销吗').then(function () {
        (0, _order.confirmGoodsApi)({
          subDistributionOrder: data.subDistributionOrderId
        }).then(function (res) {
          _this3.$message({
            type: 'success',
            message: '提交成功'
          });
          _this3.subSuccess();
        });
      });
    },
    //退款申请  退款详情
    handleRefundDetail: function handleRefundDetail(data) {
      this.$router.push({
        name: 'retailerRefund',
        params: {
          platformOrderNo: data.platformOrderNo
        }
      });
    },
    //退款申请
    handleRefund: function handleRefund(data) {
      console.log(data);
      //重置form 数据
      Object.assign(this.$data.form, this.$options.data().form);
      this.dialogFormVisible = true;
      this.form.subDistributionOrderId = data.subDistributionOrderId;
    },
    handleOnsubmitRefund: function handleOnsubmitRefund() {
      var _this4 = this;
      (0, _order.refundInitMallApi)(this.form).then(function (res) {
        if (res.initByApply) {
          _this4.form.channelDataVisBle = false;
          //获得退款初始化要求
          _this4.form.maxRefundFee = res.maxRefundFeeData.maxRefundFee;
          console.log(res.refundReasonList);
          res.refundReasonList.forEach(function (item) {
            if (item.proofRequired) {
              _this4.form.proofRequired = true;
            }
          });
        } else {
          _this4.dialogFormVisible = false;
          _this4.$message.success('退款成功');
        }
      });
    },
    handleUploadForm: function handleUploadForm(param) {
      var _this5 = this;
      var formData = new FormData();
      var data = {
        model: 'finance',
        pid: 0
      };
      formData.append('multipart', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _systemSetting.fileImageApi)(formData, data).then(function (res) {
        loading.close();
        _this5.$message.success('上传成功');
        _this5.form.sliderImages.push(res.url);
        console.log(res.url);
        console.log(_this5.form);
      }).catch(function (res) {
        loading.close();
      });
    },
    getDetail: function getDetail(data) {
      var _this6 = this;
      this.loading = true;
      (0, _order.orderDetailApi)({
        orderNo: data.platformOrderNo
      }).then(function (res) {
        _this6.orderDatalist = res;
        _this6.orderDatalist.supplierResult = data.supplierOrderDetail.supplierCodeResultJson;
        _this6.orderDatalist.supplierResult.serviceName = data.supplierOrderDetail.productName;
        _this6.channelVisBle = _this6.orderDatalist.supplierOrderDetailList.length > 0;
        _this6.loading = false;
      }).catch(function () {
        _this6.orderDatalist = null;
        _this6.loading = false;
      });
    },
    getDetailByPlatformOrderTradeId: function getDetailByPlatformOrderTradeId(id) {
      var _this7 = this;
      this.loading = true;
      (0, _order.orderDetailApiByRetailer)({
        orderNo: id
      }).then(function (res) {
        _this7.orderDatalist = res;
        _this7.loading = false;
      }).catch(function () {
        _this7.orderDatalist = null;
        _this7.loading = false;
      });
    }
  }
};